import { GenericExportFieldEnum as Fields } from 'Common/FieldEnum';
import moment from 'moment';
import { DATE_FORMAT_FOR_DB_STRING } from 'Common/Constants';
import { findIndex } from 'lodash';

export const buildFileName = (exportFileType, formValues) => {
  if (exportFileType) {
    const index = findIndex(exportFileType, x => {
      return x.Id === formValues[Fields.ExportFileType];
    });

    if (index !== -1) {
      return `${exportFileType[index].FileNamePrefix}${moment().format(
        DATE_FORMAT_FOR_DB_STRING
      )}.${exportFileType[index].FileExtention}`;
    }
  }

  return 'export.txt';
};



// WEBPACK FOOTER //
// ./src/pages/genericexport/helpers/index.js